var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_3143636",
    enableBackground: "new 0 0 299.063 299.063",
    height: 512,
    viewBox: "0 0 299.063 299.063",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.343 26.972h-217.623c-19.202 0-34.769 15.567-34.769 34.769v202.553c0 19.202 15.567 34.769 34.769 34.769h217.623c19.202 0 34.769-15.567 34.769-34.769v-202.553c0-19.203-15.567-34.769-34.769-34.769z",
    fill: "#ebf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.112 92.299v-42.128c0-19.202-15.567-34.769-34.769-34.769h-217.623c-19.202 0-34.769 15.567-34.769 34.769v42.128z",
    fill: "#ce412d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.112 100.159v-38.418c0-19.202-15.567-34.769-34.769-34.769h-217.623c-19.202 0-34.769 15.567-34.769 34.769v38.418z",
    fill: "#e56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.902 45.645c-6.702 0-12.135 5.433-12.135 12.135s5.433 12.134 12.135 12.134 12.134-5.433 12.134-12.134c.001-6.702-5.432-12.135-12.134-12.135z",
    fill: "#d15241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.902 0c-3.585 0-6.492 2.907-6.492 6.492v50.581c0 3.586 2.907 6.492 6.492 6.492s6.492-2.906 6.492-6.492v-50.581c0-3.585-2.906-6.492-6.492-6.492z",
    fill: "#4d5c7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.655 45.645c-6.702 0-12.135 5.433-12.135 12.135s5.433 12.134 12.135 12.134 12.134-5.433 12.134-12.134c.001-6.702-5.432-12.135-12.134-12.135z",
    fill: "#d15241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.655 0c-3.585 0-6.492 2.907-6.492 6.492v50.581c0 3.586 2.907 6.492 6.492 6.492s6.492-2.906 6.492-6.492v-50.581c0-3.585-2.907-6.492-6.492-6.492z",
    fill: "#4d5c7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.408 45.645c-6.702 0-12.135 5.433-12.135 12.135s5.433 12.134 12.135 12.134 12.134-5.433 12.134-12.134c0-6.702-5.432-12.135-12.134-12.135z",
    fill: "#d15241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.408 0c-3.585 0-6.492 2.907-6.492 6.492v50.581c0 3.586 2.907 6.492 6.492 6.492s6.492-2.906 6.492-6.492v-50.581c0-3.585-2.907-6.492-6.492-6.492z",
    fill: "#4d5c7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.161 45.645c-6.702 0-12.135 5.433-12.135 12.135s5.433 12.134 12.135 12.134 12.134-5.433 12.134-12.134c0-6.702-5.433-12.135-12.134-12.135z",
    fill: "#d15241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.16 0c-3.585 0-6.492 2.907-6.492 6.492v50.581c0 3.586 2.907 6.492 6.492 6.492s6.492-2.906 6.492-6.492v-50.581c0-3.585-2.906-6.492-6.492-6.492z",
    fill: "#4d5c7d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e56353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.907 148.197h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.911 148.197h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.916 148.197h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.902 189.34h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.907 189.34h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.911 189.34h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.916 189.34h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.902 230.483h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.907 230.483h26.245v26.245h-26.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.911 230.483h26.245v26.245h-26.245z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9e5aa72afb9085231fc4ded5f29f7cf0.svg";
export { ForwardRef as ReactComponent };